import React, { Component } from "react";
import { ENocMollakProps, EnocTrackIndex } from "./index";
import { BuyerInfo, ENocMollakData, EnocMollakDocuments, Mode, OwnerType } from "../../enocapi/entities";
import { LocaleUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import * as ENocMApi from "../../enocapi/api";
import { uploadDocs } from "../../enocapi/services";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { JQModal } from "@my-dld/components/Popup/Utils";
import SuccessPopup from "./SuccessPopup";
import { navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";
import ConfirmationPopup from "../../components/Popup/ConfirmationPopup";

interface Props extends ENocMollakProps {

}

interface State {
	buyers: BuyerInfo[];
	applicationRef?: string;
	enocModel: ENocMollakData;
	showConfirmationAtPosition: number;
}

export default class BuyerList extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let p = this.props.getBuyers();
		this.state = {
			buyers: p,
			enocModel: this.props.getENocData(),
			showConfirmationAtPosition: -1,
		};
		if ( p.length === 0 ) {
			this.onPrevious();
		}
		this.onSuccessDismiss = this.onSuccessDismiss.bind( this );
		this.backToPage = this.backToPage.bind( this );
	}

	componentWillUnmount() {
		JQModal( "ENocMollakSuccessPopup" ).hide();
	}

	render() {
		const { enocModel, showConfirmationAtPosition } = this.state;
		const headerProps = { className: "ui-state-default sorting_disabled", rowSpan: 1, colSpan: 1 };
		return <React.Fragment>
			<div className="row">
				<div className="col-md-12">
					<div className="alert alert-info fit-content">
						<span>{ Strings.total_area_size_enoc }
							<b>{ enocModel.totalArea + " " + Strings.sq_mt }</b> { Strings.total_size_eq_to_property_size }</span>
					</div>
				</div>
				<div className="col-md-12 table-box mb-3">
					<div className="noc-table">
						<table
							id={ "buyerDataTable_wrapper" }
							className="table table-borderless table-condensed table-striped table-responsive-sm dataTable no-footer">
							<thead>
							<tr>
								<th { ...headerProps }>{ Strings.srial_number }</th>
								<th { ...headerProps }>{ Strings.name_english }</th>
								<th { ...headerProps }>{ Strings.name_arabic }</th>
								<th { ...headerProps }>{ Strings.ownership_type }</th>
								<th { ...headerProps }>{ Strings.share_owned + " (" + Strings.sq_mt + ")" }</th>
								<th { ...headerProps }/>
							</tr>
							</thead>
							<tbody>
							{
								this.state.buyers.map( ( value, index ) => {
									return this.renderRow( value, index );
								} )
							}
							</tbody>
						</table>
					</div>
				</div>
				{
					( enocModel.mode === Mode.EDIT || enocModel.mode === Mode.VIEW ) && ( enocModel.remarks || enocModel.documents ) &&
					<div className="col-md-12 table-box mb-3">
						<div className="flex-grid flex-grid-modal mb-0">
							{
								enocModel.remarks &&
								<div>
									<span>{ Strings.remarks }</span>
									<span>{ enocModel.remarks }</span>
								</div>
							}
							{
								enocModel.documents &&
								<div>
									<span>{ Strings.documents }</span>
									<span className="flex-grid-pdf">
                                        {
	                                        enocModel.documents.map( ( value: EnocMollakDocuments, index: number ) => {
		                                        let fileUrl = value.url!;
		                                        let fileName = LocaleUtil.getLocalValue( value.documentCategory );
		                                        return <a
			                                        key={ `enoc_req_doc_${ index }` }
			                                        onClick={ () => {
				                                        window.open( fileUrl );
			                                        } }>
			                                        <i className="icon-pdf-o"/>{ fileName }</a>;
	                                        } )
                                        }
                                    </span>
								</div>
							}
						</div>
					</div>
				}
				{
					enocModel.mode != Mode.VIEW &&
					<div className="col-md-12">
						<button onClick={ this.onSubmit } className="btn btn_1 btn_style1" type="submit">
							{ Strings.submit_label }
						</button>
						<a onClick={ this.backToPage } className="btn btn-grey btn_style1 ms-2 me-2">{ Strings.close_label }</a>
					</div>
				}
				{
					enocModel.mode === Mode.VIEW &&
					<div className="col-md-12">
						<button onClick={ this.backToPage } className="btn btn_1 btn_style1" type="submit">
							{ Strings.close_label }
						</button>
					</div>
				}
			</div>
			{
				showConfirmationAtPosition > -1 && <ConfirmationPopup
					message={ Strings.buyer_delete_confirm }
					onConfirm={ () => {
						this.onDelete( showConfirmationAtPosition );
					} }
					onCancel={ this.hideConfirmation }/>
			}
			<SuccessPopup
				applicationRef={ this.state.applicationRef }
				onDismiss={ this.onSuccessDismiss }/>
		</React.Fragment>;
	}

	hideConfirmation = () => {
		this.setState( { showConfirmationAtPosition: -1 } );
	};

	backToPage = () => {
		if ( this.state.enocModel.mode === Mode.EDIT || this.state.enocModel.mode === Mode.VIEW ) {
			navigate( "/mydld/my_requests" );
		} else {
			const property = this.props.getTabuProperty();
			replaceNavigate( "/mydld/" + "property/" + property.propertyTypeId + "/" + property.tabuPropertyId );
		}
	};

	renderRow( item: BuyerInfo, index: number ) {
		const data: BuyerInfo = item as any;
		const isCompany: boolean = data.ownershipType?.identity === OwnerType.COMPANY;
		return (
			<tr role={ "row" } className={ index % 2 === 0 ? "odd" : "even" } key={ "buyer" + index }>
				<td tabIndex={ 0 }>{ ( index + 1 ) + "." }</td>
				<td>{ isCompany ? data.CompanyNameEn : data.PersonNameEn }</td>
				<td>{ isCompany ? data.CompanyNameAr : data.PersonNameAr }</td>
				<td>{ LocaleUtil.getLocalValue( data.ownershipType ) }</td>
				<td>{ LocaleUtil.getLocalValue( data.propertyShareValue ) }</td>
				<td className="td-action">
					<button
						className="btn btn-sm" onClick={ () => {
						this.onEdit( index );
					} }>
						<i className="far fa-arrow-alt-circle-right"/>
					</button>
					{
						this.state.enocModel.mode === Mode.CREATE &&
						<button
							className="btn btn-sm" onClick={ () => {
							this.setState( { showConfirmationAtPosition: index } );
						} }>
							<i className="fa fa-trash-alt"/>
						</button>
					}
				</td>
			</tr>
		);
	}

	onEdit = ( position: number ) => {
		this.props.setIndex( position, () => {
			this.props.onNext( EnocTrackIndex.BUYER_DETAILS );
		} );
	};

	onDelete = ( position: number ) => {
		let temp = this.state.buyers;
		temp.splice( position, 1 );
		this.setState( { buyers: temp }, () => {
			if ( this.state.buyers.length < 1 ) {
				this.onPrevious();
			}
		} );
	};

	onPrevious = () => {
		// this.props.setIndex(-1, () => {this.props.onPrevious(EnocTrackIndex.BUYER_DETAILS);});
		this.props.setIndex( -1, () => {
			this.props.onNext( EnocTrackIndex.BUYER_DETAILS );
		} );
	};

	onSubmit = () => {
		let enocModel = this.props.getENocData();
		let requireDocs: EnocMollakDocuments[] = [];
		let buyers: BuyerInfo[] = [];
		let total: number = 0;
		this.state.buyers.forEach( ( value, index ) => {
			const m: BuyerInfo = value;
			total = total + Number( m.propertyShareValue );
		} );
		const a = Number( total ).toFixed( 2 );
		const b = Number( enocModel.totalArea ).toFixed( 2 );
		if ( a !== b ) {
			showMessage( Strings.property_size_eq_share_value );
			hideLoading();
			return;
		}
		this.state.buyers.forEach( ( value ) => {
			const buyer = value;
			const isCompany = buyer.ownershipType?.identity === OwnerType.COMPANY;
			const person = {
				englishName: isCompany ? buyer.ManagerNameEn : buyer.PersonNameEn,
				arabicName: isCompany ? buyer.ManagerNameAr : buyer.PersonNameAr,
			};
			const passportValidity = {
				startDate: buyer.startDate,
				endDate: buyer.endDate,
			};
			const company = {
				englishName: buyer.CompanyNameEn,
				arabicName: buyer.CompanyNameAr,
			};
			const contact = {
				email: buyer.email,
				mobile: buyer.mobile,
			};
			buyers.push( {
				...buyer,
				PersonNameAr: undefined,
				PersonNameEn: undefined,
				ManagerNameAr: undefined,
				ManagerNameEn: undefined,
				startDate: undefined,
				endDate: undefined,
				licenseAuthority: buyer.ownershipType?.identity === OwnerType.INDIVIDUAL ? undefined : buyer.licenseAuthority,
				companyName: buyer.ownershipType?.identity === OwnerType.COMPANY ? company : undefined,
				managerName: person,
				passportValidity: passportValidity,
				contact: contact,
				propertyShareValue: Number( buyer.propertyShareValue ),
				emiratesID: buyer.emiratesID ? String( buyer.emiratesID ) : undefined,
				passportNumber: buyer.passportNumber ? String( buyer.passportNumber ) : undefined,
				tradeLicenseNumber: buyer.ownershipType?.identity === OwnerType.INDIVIDUAL ? undefined : String( buyer.tradeLicenseNumber ),
			} );
			requireDocs.push( ...buyer.documents! );
		} );

		this.uploadDocuments( requireDocs ).then( response => {
			this.finalSubmission( enocModel, buyers );
		} ).catch( reason => {
			hideLoading();
		} );
	};

	uploadDocuments( documents: EnocMollakDocuments[] ): Promise<any> {
		showLoading();
		if ( documents && documents.length > 0 ) {
			return uploadDocs( documents );
		} else {
			return Promise.resolve();
		}
	}

	finalSubmission( enocModel: ENocMollakData, buyers: BuyerInfo[] ) {
		enocModel.buyerInfo = buyers;
		enocModel.workflowComment = undefined;
		enocModel.recordSourceId = 0;
		const propertyID = enocModel.mollakPropertyId;
		ENocMApi.submitENocMollakRequest( enocModel, propertyID! ).then( ( resp: any ) => {
			hideLoading();
			let nocReferenceNo: string | undefined = undefined;
			const isResubmit = enocModel.mode === Mode.EDIT;
			if ( isResubmit ) {
				nocReferenceNo = enocModel.nocReferenceNo;
			} else {
				nocReferenceNo = resp && resp.additionalData && resp.additionalData.nocReferenceNo ? resp.additionalData.nocReferenceNo : undefined;
			}
			if ( nocReferenceNo ) {
				this.setState( { applicationRef: nocReferenceNo } );
				JQModal( "ENocMollakSuccessPopup" ).show();
				trackEventWithData( "eNocMollak", isResubmit ? "ResubmitRequestSuccess" : "CreateRequestSuccess", {
					id: enocModel.mollakPropertyId!.toString(),
					application: nocReferenceNo,
				} );
			}
		} ).catch( reason => {
			hideLoading();
			const isResubmit = enocModel.mode === Mode.EDIT;
			trackEventWithData( "eNocMollak", isResubmit ? "ResubmitRequestFail" : "CreateRequestFail", {
				id: enocModel.mollakPropertyId!.toString(),
				reason: reason.message,
			} );
			showMessage( reason.message );
		} );
	}

	private onSuccessDismiss = () => {
		JQModal( "ENocMollakSuccessPopup" ).hide();
		this.props.history.goBack();
	};

}
